import { c as _c } from "react/compiler-runtime";
// Залитый вариант иконки чата — активное состояние в шапке и нижнем меню
// (Айталы A-04: «иконка чата в активном состоянии с заливкой»). Отдельного
// залитого рисунка в макете нет, поэтому знак собран из вектора макета
// `Outline/Chat` (ChatIcon в src/components/icons/header.tsx): внешний контур
// пузыря залит цветом иконки, три точки — белые, как точки поверх заливки.
import { Svg, type IconProps } from "@/components/icons/icon";
export function ChatFilledIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M11.7244 22.494C10.1964 22.494 8.65844 22.171 7.21944 21.505C6.79544 21.335 6.39844 21.175 6.11344 21.175C5.78544 21.177 5.34444 21.329 4.91844 21.476C4.04444 21.776 2.95644 22.15 2.15144 21.348C1.34944 20.545 1.71944 19.46 2.01744 18.587C2.16444 18.157 2.31544 17.713 2.31544 17.377C2.31544 17.101 2.18244 16.749 1.97844 16.242C0.105437 12.197 0.971437 7.322 4.14844 4.147C6.17644 2.118 8.87544 1 11.7484 1C14.6214 1 17.3214 2.117 19.3494 4.146C23.5414 8.338 23.5414 15.158 19.3494 19.35C17.2944 21.406 14.5274 22.494 11.7244 22.494Z" fill="currentColor" />;
    t3 = <path d="M15.6954 13.1631C15.1434 13.1631 14.6914 12.7161 14.6914 12.1631C14.6914 11.6101 15.1344 11.1631 15.6864 11.1631H15.6954C16.2474 11.1631 16.6954 11.6101 16.6954 12.1631C16.6954 12.7161 16.2474 13.1631 15.6954 13.1631Z" fill="#FFFFFF" />;
    t4 = <path d="M11.6876 13.1631C11.1356 13.1631 10.6836 12.7161 10.6836 12.1631C10.6836 11.6101 11.1256 11.1631 11.6786 11.1631H11.6876C12.2396 11.1631 12.6876 11.6101 12.6876 12.1631C12.6876 12.7161 12.2396 13.1631 11.6876 13.1631Z" fill="#FFFFFF" />;
    t5 = <path d="M7.67783 13.1631C7.12583 13.1631 6.67383 12.7161 6.67383 12.1631C6.67383 11.6101 7.11683 11.1631 7.66883 11.1631H7.67783C8.22983 11.1631 8.67783 11.6101 8.67783 12.1631C8.67783 12.7161 8.22983 13.1631 7.67783 13.1631Z" fill="#FFFFFF" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props || $[8] !== size) {
    t6 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}{t4}{t5}</Svg>;
    $[7] = props;
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}